var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      cursor: "pointer"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6809 3.32194C14.9183 1.55935 12.0661 1.55935 10.3056 3.32194L8.28677 5.34079L9.34932 6.40334L11.3682 4.38449C12.4891 3.2636 14.3808 3.14485 15.6184 4.38449C16.858 5.62414 16.7393 7.51381 15.6184 8.6347L13.5995 10.6535L14.6642 11.7182L16.683 9.69933C18.4414 7.93675 18.4414 5.08453 16.6809 3.32194ZM8.63678 15.6184C7.5159 16.7393 5.62414 16.858 4.38658 15.6184C3.14693 14.3787 3.26569 12.4891 4.38658 11.3682L6.40542 9.34932L5.34079 8.28468L3.32194 10.3035C1.55935 12.0661 1.55935 14.9183 3.32194 16.6788C5.08453 18.4393 7.93675 18.4414 9.69725 16.6788L11.7161 14.66L10.6535 13.5974L8.63678 15.6184ZM4.75743 3.69696C4.69222 3.63237 4.58721 3.63237 4.522 3.69696L3.69696 4.522C3.63237 4.58721 3.63237 4.69221 3.69696 4.75743L15.2475 16.308C15.3121 16.3726 15.4184 16.3726 15.483 16.308L16.308 15.483C16.3726 15.4184 16.3726 15.3121 16.308 15.2475L4.75743 3.69696Z",
    fill: "#9292AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOff);
export default __webpack_public_path__ + "static/media/link-off.b8ecab7135395e6470e74f87e38a419f.svg";
export { ForwardRef as ReactComponent };